import { createIcon } from "@chakra-ui/icons";

export const Edit2Icon = createIcon({
  displayName: "Edit2Icon",
  viewBox: "0 0 12 12",
  path: (
    <path
      d="M9.00001 5L7.00001 3M1.25 10.75L2.94218 10.562C3.14893 10.539 3.2523 10.5275 3.34892 10.4962C3.43464 10.4685 3.51622 10.4293 3.59144 10.3797C3.67623 10.3238 3.74977 10.2502 3.89686 10.1031L10.5 3.5C11.0523 2.94771 11.0523 2.05228 10.5 1.5C9.94773 0.947714 9.0523 0.947714 8.50001 1.5L1.89686 8.10314C1.74977 8.25023 1.67623 8.32377 1.62032 8.40856C1.57072 8.48378 1.53151 8.56535 1.50376 8.65108C1.47248 8.7477 1.46099 8.85107 1.43802 9.05782L1.25 10.75Z"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  defaultProps: {
    width: "12px",
    height: "12px",
  },
});
